<template>
  <v-row dense>
    <v-col cols="12">
      <int-editor ref="item_mobile" validate-on-blur v-model="data.mobile" dense outlined class="rounded-0" autocomplete="off" label="手机号" :rules="[rules.required,rules.mobile]" @keydown.native="onMobileKeydown"></int-editor>
    </v-col>
    <v-col cols="12">
      <v-text-field ref="item_password" validate-on-blur v-model="data.password" dense type="password" autocomplete="off" outlined class="rounded-0" label="登录密码(区分大小写)" :rules="[rules.required]" @keydown.native="onPasswordKeydown"></v-text-field>
    </v-col>
    <v-col cols="12" v-if="loginVerifyCode">
      <v-row dense>
        <v-col cols="7">
          <v-text-field ref="item_verifyCode" validate-on-blur v-model="data.verifyCode" dense outlined class="rounded-0" autocomplete="off" label="图片验证码" :rules="[rules.required]" @keydown.native="onVerifyCodeKeydown"></v-text-field>
        </v-col>
        <v-col cols="5">
          <v-img :src="verifyCodeUrl" @click="onRefreshVerifyCode" contain height="37"></v-img>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */
import md5 from 'md5';
import { required, mobile } from '@/plugins/rules';

export default {
  props: {
    loginVerifyCode: { type: Boolean, default: false }
  },
  data () {
    return {
      data: {},
      verifyCodeUrl: `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`,
      rules: { required: required(), mobile: mobile() }
    }
  },
  mounted () {
    this.$refs.item_mobile.focus();
  },
  methods: {
    getLoginData () {
      let ret = this.Utility.clone(this.data);
      ret.password = md5(ret.password);
      return ret;
    },
    onMobileKeydown (e) {
      if (e.keyCode == 13) {
        this.$refs.item_password.focus();
      }
    },
    onPasswordKeydown (e) {
      if (e.keyCode == 13) {
        if (this.loginVerifyCode) {
          this.$refs.item_verifyCode.focus();
        } else {
          this.$emit('login');
        }
      }
    },
    onVerifyCodeKeydown (e) {
      if (e.keyCode == 13) {
        this.$emit('login');
      }
    },
    validate () {
      if (!this.data.mobile) return '请填写注册手机号';
      if (!this.data.password) return '请填写登录密码';
      if (this.loginVerifyCode && !this.data.verifyCode) return '请输入图片验证码';
      return true;
    },
    onRefreshVerifyCode () {
      this.verifyCodeUrl = `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`;
    }
  }
}
  </script>